






import Vue from 'vue';
import mixins from '../../mixins';

// eslint-disable-next-line no-unused-vars
type UnregisterType = (item: Vue)=>void;
// eslint-disable-next-line no-unused-vars
type RegisterType = (item: Vue)=>void;
type RegisteringMethodsType = {register: RegisterType[], unregister: UnregisterType[]};

export default mixins().extend({
  props: {
    value: { type: undefined, default: undefined },
    tag: { type: String, default: 'div' },
    namespace: { type: String, default: 'default' },
    /** Registers **only** with the topmost parent, default behaviour is to register with closest only */
    registerOnlyWithRootParent: { type: Boolean, default: false },
    /** Registers with all parents above this child, default behaviour is to register with closest only */
    registerWithAllParents: { type: Boolean, default: false },
  },
  methods: {
    getRegisteringMethods(): RegisteringMethodsType {
      const result = { register: [], unregister: [] } as RegisteringMethodsType;
      // As inspired by -> https://github.com/vuejs/vue/blob/b51430f598b354ed60851bb62885539bd25de3d8/src/core/instance/inject.js#L53
      // Custom way to get the un/register methods because namespaces are needed
      let parents = [] as any[];
      let p = this.$parent as any;
      while (p) {
        const tag = (p as Vue).$vnode?.tag ?? '';
        const namespace = p.namespace as string;
        const matchesNamespace = namespace && namespace.toLowerCase() === this.namespace.toLowerCase();
        if (tag.includes('p-parent') && matchesNamespace) {
          parents.push(p);
          if (!this.registerOnlyWithRootParent && !this.registerWithAllParents) {
            break;
          }
        }
        p = p.$parent;
      }
      if (this.registerOnlyWithRootParent) {
        const topMostParent = parents.pop();
        if (topMostParent) {
          parents = [topMostParent];
        }
      }
      parents.forEach((parent) => {
        // eslint-disable-next-line no-underscore-dangle
        const provided = parent._provided;
        if (provided) {
          if (typeof provided.register === 'function') {
            result.register.push(provided.register);
          }
          if (typeof provided.unregister === 'function') {
            result.unregister.push(provided.unregister);
          }
        }
      });
      return result;
    },
    registerWithParent() {
      const self = this;

      const registeringMethods = this.getRegisteringMethods();
      const allRegister = registeringMethods.register;
      allRegister.forEach((register) => {
        if (typeof this.$listeners.register === 'function') {
          this.$emit('register', register);
        } else {
          register(self);
        }
      });
    },
    unregisterWithParent() {
      const self = this;

      const registeringMethods = this.getRegisteringMethods();
      const allUnregister = registeringMethods.unregister;

      allUnregister.forEach((unregister) => {
        if (typeof this.$listeners.register === 'function') {
          this.$emit('unregister', unregister);
        } else {
          unregister(self);
        }
      });
    },
  },
  mounted() {
    this.registerWithParent();
  },
  beforeDestroy() {
    this.unregisterWithParent();
  },
});
